import React from "react";
import NewAudioOrVideo from "./NewAudioOrVideo";
import MessageTypeImageInChat from "./MessageTypeImageInChat";
import { getFileNameFromUrl } from "../../../../../helpers/getFileNameFromUrl";
import { downloadFileFromUrl } from "../../../../../helpers/downloadFileFromUrl";

//Iconos de Material UI.
import { InsertDriveFile } from '@mui/icons-material/';

// MessageByTypeInChat: Componente que renderiza el mensaje dentro del chat de la sesión abierta según su tipo.

const MessageByTypeInChat = ({ mensaje }) => {

    const handleDownloadFile = (src) => {//Función para descargar un archivo multimedia.
        let nameFile = getFileNameFromUrl(src);
        downloadFileFromUrl(src, nameFile);
    };

    const wrapUrlsWithAnchorTags = (text) => { //Función para agregar links en el mensaje.
        const urlRegex = /(https?:\/\/[^\s]+)/g; // Expresión regular para detectar URLs en el texto
        return text.replace(urlRegex, (url) => { // Reemplazar cada URL encontrada con un enlace cliclable
            return `<a href="${url}" target="_blank">${url}</a>`;
        });
    };

    return (
        <>
            {/*-----Renderiza un mensaje de tipo texto-------*/}
            {mensaje.Type === "text" && mensaje.Message && (mensaje.Entrante
                ?
                <div className="message-entrante">
                    <div className="hour-with-message entrante">
                        <pre className={`message ${mensaje.Entrante ? "entrante" : "saliente"}`}
                         dangerouslySetInnerHTML={{ __html: wrapUrlsWithAnchorTags(mensaje.Message.trim()) }} />
                    </div>

                </div>
                :
                <div className="message-saliente">
                    <div className="hour-with-message saliente">
                        <pre className={`message ${mensaje.Entrante ? "entrante" : "saliente"}`} dangerouslySetInnerHTML={{ __html: wrapUrlsWithAnchorTags(mensaje.Message.trim()) }} />
                    </div>
                </div>)
            }

            {/*-----Renderiza un mensaje de tipo audio-------*/}
            {mensaje.Type === "audio" && <NewAudioOrVideo entrante={mensaje.Entrante} 
            messageHour={mensaje.FechaHora} type={"audio"} src={mensaje.UrlFile} />}

            {/*-----Renderiza un mensaje de tipo audio-------*/}
            {mensaje.Type === "video" && <NewAudioOrVideo entrante={mensaje.Entrante} 
            messageHour={mensaje.FechaHora} type={"video"} src={mensaje.UrlFile} />}

            {/*-----Renderiza un mensaje de tipo imagen-------*/}
            {mensaje.Type === "image" && <MessageTypeImageInChat entrante={mensaje.Entrante} src={mensaje.UrlFile} 
            mensaje={mensaje.Message} messageData={mensaje}/>}

            {/*-----Renderiza un mensaje de tipo sticker-------*/}
            {mensaje.Type === "sticker" && <img className="sticker-message" 
            src={mensaje.UrlFile}></img>}

            {/*-----Renderiza un mensaje de tipo texto-------*/}
            {mensaje.Type === "document" && (mensaje.Entrante
                ?
                <div className="message-entrante">
                    <div className="hour-with-message document" 
                    onClick={() => handleDownloadFile(mensaje.UrlFile)}>
                        <label><InsertDriveFile sx={{ fontSize: "20px", marginRight: "10px" }} />
                        {getFileNameFromUrl(mensaje.UrlFile)}</label>
                    </div>
                    {mensaje.Message && <span className={`message-image__text ${mensaje.Entrante ? "entrante" : "saliente"}`}>{mensaje.Message}</span>}
                </div>
                :
                <div className="message-saliente">
                    <div className="hour-with-message document" onClick={() => handleDownloadFile(mensaje.UrlFile)}>
                        <label><InsertDriveFile sx={{ fontSize: "20px", marginRight: "10px" }} />
                        {getFileNameFromUrl(mensaje.UrlFile)}</label>
                    </div>
                    {mensaje.Message && <span className={`message-image__text ${mensaje.Entrante ? "entrante" : "saliente"}`}>{mensaje.Message}</span>}
                </div>)
            }

        </>
    )
};

export default MessageByTypeInChat;